module.exports = __webpack_public_path__ + "images/640469f551125de7cd469cf2ed398496-IMG_5131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_5131.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_5131.jpg
// module chunks = 0